import styled, { css } from 'styled-components';

const Text18 = styled.div`
  font-family: ${({ font }) => font ? font : 'InterRegular'} , sans-serif;
  font-size: 18px;
  line-height:${({ height }) => height ? height : 24}px;
  text-align: ${({ align }) => align ? align : 'left'};
  color: ${({ color }) => color ? color : 'black'};
  column-count:${({ withCols }) => withCols ? 2 : 1};

  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}

  b{
    font-family: 'InterBold', sans-serif;
  }

  strong{
    font-family: 'InterBold' , sans-serif;
  }

  a{
    color:#6F6F6E;
    :hover{
      cursor: pointer;
      color:#E3000F;
    }
  }
  
  p{
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  @media screen and (max-width: 768px) {
    column-count:1;
    font-size: 16px;
    line-height: 18px;
  }
`;

export default Text18;